import { connect } from 'react-redux';
import SubmitReview from './SubmitReview';
import { fetchReviewSettings, submitReview } from '../../actions/reviews';
import { cancelMembername, finishMembername } from '../../actions/user';

function mapStateToProps({ auth, reviews, user }) {
  return {
    isLoggedIn: !!auth.account_id,
    isFetchingCategories: reviews.isFetchingSettings,
    error: reviews.error,
    hasDisabledReviews: reviews.hasDisabledReviews,
    isDisabledMessage: reviews.isDisabledMessage,
    ratingCategories: reviews.ratingCategories,
    isSubmittingReview: reviews.isSubmitting,
    reviewSubmitted: reviews.reviewSubmitted,
    submitError: reviews.error,
    memberName: user.name,
    canSetMembername: user.tags?.generatedMembername || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchReviewSettings: stationId => dispatch(fetchReviewSettings(stationId)),
    submitReview: body => dispatch(submitReview(body)),
    onMembernameUpdateCancel: () => dispatch(cancelMembername()),
    onMembernameUpdateFinish: () => dispatch(finishMembername()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitReview);
